import { render, staticRenderFns } from "./LmBtnListado.vue?vue&type=template&id=32b046bc&"
import script from "./LmBtnListado.vue?vue&type=script&lang=js&"
export * from "./LmBtnListado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports